import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { FormBuilder, FormGroup, FormControl } from '@angular/forms'; 
import {
  startWith,
  map,
  debounceTime,
  mergeMapTo,
  mergeMap,
  switchMap,
  catchError
} from 'rxjs/operators';
import { Observable } from 'rxjs'; // only need to import from rxjs
import { ServiceService, ServiceSummary } from '../../services/service.service';
import { EmptyObservable } from 'rxjs/observable/EmptyObservable';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
 

@Component({
  selector: 'app-service-edit-related-service-lookup',
  templateUrl: './service-edit-related-service-lookup.component.html',
  styleUrls: ['./service-edit-related-service-lookup.component.css']
})
export class ServiceEditRelatedServiceLookupComponent implements OnInit {

  public autoComplete$: Observable<any> = null;
  public autoCompleteControl = new FormControl(); 
  @Output() serviceSelected: EventEmitter<ServiceSummary> = new EventEmitter();
  @Input() public defaultServiceName: string;

  constructor(private serviceSvc: ServiceService) { }

  ngOnInit() {
  
    console.log(this.defaultServiceName);
    

    this.autoComplete$ = this.autoCompleteControl.valueChanges.pipe(
      startWith(''),
      // delay emits
      debounceTime(400),
      // use switch map so as to cancel previous subscribed events, before creating new once
      switchMap(value => {

        //console.log(value);
        if (value !== '' && value.length > 1) { 
          return this.lookup(value);
        } else {
          return  new EmptyObservable();
        }
      })
    );

  }
 
  public optionSelected(event: MatAutocompleteSelectedEvent) {
    console.log("optionSelected", event.option);
    this.serviceSelected.emit(event.option.value);
  }

  public displayFn(obj: any) {
    //console.log("display fn: ", obj);
    if (obj) {return obj.Name}
  }

  public lookup(value: string): Promise<any> { 
    return this.serviceSvc.getSummaryForAutoSuggest(value);
  }

}
